export const isValidLatLng = (lat, lng) => {
    // Check if latitude is within the range of -90 to 90
    if (isNaN(lat) || lat < -90 || lat > 90) {
        return false;
    }

    // Check if longitude is within the range of -180 to 180
    if (isNaN(lng) || lng < -180 || lng > 180) {
        return false;
    }

    // If both latitude and longitude are valid, return true
    return true;
}